
import useBreakpoint from '@/hooks/useBreakpoint';
import './styles.css';

const LoadingAddress: React.FC = () => {
  const { isOnBreakpoint } = useBreakpoint(600);
  return (
    <>
      <div className='modal absolute top-0 h-64 w-full bg-white opacity-75' />
      <div className='loader' />
      <span
        className={`model-label text-xl font-normal text-tim-primary lg:text-2xl ${
          isOnBreakpoint ? 'mobile' : 'desktop'
        }`}
      >
        Procurando Endereço...
      </span>
    </>
  );
};

export default LoadingAddress;
